import axios from 'axios'
// STATE
export const auth = {
    userId: "",
    channelId: '',
    channelHandle: '',
    visitedChannelHandle: '',
    visitedChannelId: '',
};

// REDUCER
export const AuthReducer = (state, action) => {
    switch (action.type) {
        case 'updateUserId':
            return { ...state, userId: action.payload.userId }
        case 'updateChannelId':
            return { ...state, channelId: action.payload.channelId }
        case 'updateChannelHandle':
            return { ...state, channelHandle: action.payload.channelHandle }
        case 'updatedAll':
            return { ...state, userId: action.payload.userId, channelId: action.payload.channelId }
        case 'updateVisitedChannelId':
            return { ...state, visitedChannelId: action.payload.visitedChannelId }
        default:
            return state
    }
}
